/*
 * @Author: git config zhang && 10899060+inheaven98@user.noreply.gitee.com
 * @Date: 2024-03-15 16:13:46
 * @LastEditors: inHeaven98 10899060+inheaven98@user.noreply.gitee.com
 * @LastEditTime: 2024-10-22 15:13:56
 * @FilePath: \cei-saas-platform\src\store\index.js
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import contract from './modules/contract'
import recordsStatus from './modules/recordsStatus'
import readChatStatus from './modules/readChatStatus'
Vue.use(Vuex)

// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context('./modules', true, /\.js$/)

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
	// set './app.js' => 'app'
	const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
	const value = modulesFiles(modulePath)
	modules[moduleName] = value.default
	return modules
}, {})

const store = new Vuex.Store({
	modules,
	getters,
	contract,
	recordsStatus,
	readChatStatus
})

export default store
